import React from 'react';
import FletesPendientes from '../../components/fletes/FletesPendientes';
import { PageWrapper } from '../../components/common';

const ListarPendienteFletes: React.FC = () => {
  return (
    <PageWrapper>
      <FletesPendientes />
    </PageWrapper>
  );
};

export default ListarPendienteFletes;